import { render, staticRenderFns } from "./Supersubcategory.vue?vue&type=template&id=b22a588c&scoped=true&"
import script from "./Supersubcategory.vue?vue&type=script&lang=js&"
export * from "./Supersubcategory.vue?vue&type=script&lang=js&"
import style0 from "./Supersubcategory.vue?vue&type=style&index=0&id=b22a588c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22a588c",
  null
  
)

export default component.exports